<template>
  <div class="login">
    <img src="../assets/image/sobuy.png" class="logo" />
    <div class="bot-box">
      <div class="input-box">
        <i class="iconfont icon-phone"></i>
        <input
          type="text"
          name="phone"
          v-model="phone"
          placeholder="请输入手机号"
        />
      </div>
      <div class="pass-box">
        <div class="input-box">
          <i class="cropper icon-yanzhengma"></i>
          <input
            type="text"
            name="phone"
            v-model="code"
            placeholder="请输入验证码"
          />
        </div>
        <div class="getcode" @click="getCode">{{ codeText }}</div>
      </div>

      <mt-button size="large" type="primary" @click="Login">登录</mt-button>
    </div>
  </div>
</template>

<script>
import { loginApi } from "../api/api";
const pageApi = new loginApi();
export default {
  data() {
    return {
      phone: "",
      code: "",
      codeText: "获取验证码",
      time: 60,
      codeLock: true,
      proofId: "",
    };
  },
  methods: {
    // 获取验证码
    async getCode() {
      if (!this.codeLock) {
        return false;
      }
      var reg =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!this.phone || !reg.test(this.phone)) {
        this.$notify({
          message: "请输入正确的手机号",
          type: "danger",
          duration: 5000,
        });
        return false;
      }
      const res = await pageApi.getCode(this.phone);
      if (res.success) {
        this.codeLock = false;
        this.codeText = "60s后再次获取";
        this.setTime();
      } else {
        this.$notify({
          message: res.message,
          type: "danger",
          duration: 5000,
        });
      }
    },
    // 倒计时
    setTime() {
      var _this = this;
      setTimeout(function () {
        _this.time--;
        if (_this.time < 1) {
          _this.codeLock = true;
          _this.codeText = "获取验证码";
        } else {
          _this.codeText = _this.time + "s后再次获取";
        }
        _this.setTime();
      }, 1000);
    },
    // 登录
    async Login() {
      var reg =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!this.phone || !reg.test(this.phone)) {
        this.$notify({
          message: "请输入正确的手机号",
          type: "danger",
          duration: 5000,
        });
        return false;
      }
      if (!this.code) {
        this.$notify({
          message: "请输入验证码",
          type: "danger",
          duration: 5000,
        });
        return false;
      }
      const info = {
        tel: this.phone,
        code: this.code,
      };
      const res = await pageApi.verifyCode(info);
      const datainfo = {
        tel: this.phone,
      };
      const data = await pageApi.login(datainfo);
      if (data.success) {
        window.localStorage.setItem("token", data.data.token.token);
        this.codeLock = true;
        this.$router.push(`/Product?proofId=${this.proofId}`);
      } else {
        this.$notify({
          message: data.message,
          type: "success",
          duration: 5000,
        });
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.proofId = from.query.proofId;
    });
  },

  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.mint-button--primary {
  background: $base_color;
  border-radius: 86px;
  height: 86px;
  font-size: 30px;
  margin-top: 28px;
}
.login {
  background: #f2f2f2;
  box-sizing: border-box;
  height: calc(100vh - 88px);
  padding-top: 104px;
  .logo {
    height: 173px;
    margin: 0 auto 104px;
    display: block;
  }
  .bot-box {
    padding: 120px 55px 0;
    background: #fff;
    box-sizing: border-box;
    height: calc(100vh - 469px);
    border-top-left-radius: 67px;
    border-top-right-radius: 67px;
    .pass-box {
      width: 100%;
      display: flex;
    }
    .input-box {
      margin-bottom: 40px;
      display: flex;
      border-radius: 12px;
      border: 1px solid #dbdbdb;
      box-sizing: border-box;
      padding: 0 33px;
      align-items: center;
      .iconfont {
        width: 28px;
        height: 28px;
        font-size: 28px;
        margin-right: 20px;
      }
      .cropper {
        width: 28px;
        height: 28px;
        font-size: 28px;
        margin-right: 20px;
      }
      input {
        width: 100%;
        height: 86px;
        line-height: 86px;
        font-size: 32px;
        background-color: #fff;
        border: 0;
        outline: none;
        color: #333;
        &:focus {
          border: none;
        }
      }
    }
    .getcode {
      width: 180px;
      height: 86px;
      border-radius: 12px;
      border: 1px solid $base_color;
      text-align: center;
      flex-shrink: 0;
      margin-left: 40px;
      background: #fff;
      color: $base_color;
      line-height: 86px;
    }
  }
}
</style>
